/**
 * Атрибут на <html>: корневой error boundary показал снимок SSR-разметки.
 */
export const APP_DEGRADED_ATTRIBUTE = 'data-app-degraded';
